import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { ConstantsService } from 'src/app/constants.service';

@Injectable({ providedIn: 'root' })
export class ReportService {
    protected http: HttpClient;
    protected constantsService: ConstantsService;
    protected apiUrl: string = '';

    protected constructor(
        http: HttpClient,
        constantsService: ConstantsService
    ) {
        this.http = http;
        this.constantsService = constantsService;

        this.constantsService.onReady(() => {
            this.apiUrl = this.constantsService.getConstant('apiUrl');
        })
    }

    protected handleError(error: any): Observable<never> {
        if (error.error instanceof Blob) {
            return from(error.error.text() as Promise<string>).pipe(
                switchMap(text => {
                    try {
                        const json = JSON.parse(text);
                        return throwError(() => new Error(json.detail || json.message || 'Something bad happened; please try again later.'));
                    } catch {
                        return throwError(() => new Error('Something bad happened; please try again later.'));
                    }
                })
            );
        }
        console.error('An error occurred:', error.error?.message || error.message || 'Server error');
        return throwError(() => new Error(error.error?.message || error.message || 'Something bad happened; please try again later.'));
    }

    downloadFile(fileName: string, path: string, startDate: string | null, endDate: string | null, format: string = 'csv') {
        // Build query parameters only for dates that are provided
        const queryParams: string[] = [];
        if (startDate) {
            queryParams.push(`fromDate=${startDate}`);
        }
        if (endDate) {
            queryParams.push(`toDate=${endDate}`);
        }

        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
        const buildedPath = `${path}${queryString}`;

        return this.http.get(`${this.apiUrl}${buildedPath}`, {
            responseType: 'blob',
            withCredentials: true
        }).pipe(
            tap(blob => {
                // Create a download link and trigger the download
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;

                // Build filename with dates if they are provided
                let fullFileName = fileName;
                if (startDate && endDate) {
                    fullFileName = `${fileName}_${startDate}_to_${endDate}`;
                } else if (startDate) {
                    fullFileName = `${fileName}_${startDate}`;
                } else if (endDate) {
                    fullFileName = `${fileName}_${endDate}`;
                }

                a.download = `${fullFileName}.${format}`; // Set the filename with extension
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }),
            catchError(this.handleError)
        );
    }

    // Keep the old method for backwards compatibility (deprecated)
    downdloadCSV(fileName: string, path: string, startDate: string, endDate: string) {
        return this.downloadFile(fileName, path, startDate, endDate, 'csv');
    }

}